import { format } from 'date-fns'
import { FileText } from 'lucide-react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface DeclarationValidateCardProps {
  userFullName: string
  courseName: string
  expiredAt?: string
  documentUrl: string
}

export default function DeclarationValidateCard({
  courseName,
  documentUrl,
  expiredAt,
  userFullName,
}: Readonly<DeclarationValidateCardProps>) {
  return (
    <Card className="mx-auto w-full max-w-md shadow-lg">
      <CardHeader className="pb-4 text-center">
        <CardTitle className="font-bold text-gray-800 text-xl tracking-wide">
          DECLARAÇÃO RECONHECIDA
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        <div className="space-y-3">
          <div>
            <span className="font-semibold text-gray-700">Aluno: </span>
            <span className="text-gray-600">{userFullName}</span>
          </div>

          <div>
            <span className="font-semibold text-gray-700">Curso: </span>
            <span className="text-gray-600">{courseName}</span>
          </div>

          {expiredAt && (
            <div>
              <span className="font-semibold text-gray-700">Expedida em: </span>
              <span className="text-gray-600">
                {format(expiredAt, 'dd/MM/yyyy')}
              </span>
            </div>
          )}

          <div className="pt-2">
            <span className="font-semibold text-gray-700">
              Cópia da Declaração:{' '}
            </span>
            <Button
              asChild
              className="h-auto p-0 font-normal text-blue-600 hover:text-blue-800"
              variant="link"
            >
              <Link href={documentUrl} target="_blank">
                <FileText className="mr-1 h-4 w-4" />
                Visualizar Cópia
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
